<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Competency' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Name' | translate}}</label>
      <input type="text" class="form-control" [(ngModel)]="entity.name" />
    </div>

    <div class="form-group">
      <label>{{'Description' | translate}}</label>
      <textarea class="form-control" [(ngModel)]="entity.description" rows="5"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Type' | translate}}</label>
      <select class="form-control" [(ngModel)]="entity.type">
        <option *ngFor="let type of competencyTypes" [value]="type.value">
          {{type.name | translate}}
        </option>
      </select>
    </div>


  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>
